module.exports = __webpack_public_path__ + "img/ai.5a195468.svg";